export default "__VITE_ASSET__78c6e403__"